/**
 * @repo/http - 同构 HTTP 请求工具
 *
 * 为 Next.js (App Router) 设计的同构 HTTP 客户端
 * 支持服务端组件、客户端组件和 Server Actions
 */

// 导出 HTTP 客户端
export { http, Http } from "./http"
export { getClientIPFromHeaders, getClientLangeuage, getClientToken, getLocaleFromUrl } from "./utils"

// 导出类型定义
export { SUCCESS_CODE } from "./constants"
export type {
  ErrorInterceptor,
  HTTPProtocol,
  HttpRequestConfig,
  LogConfig,
  LogLevel,
  RequestInterceptor,
  ResponseInterceptor,
} from "./http"

// 导出错误类
export { HttpError } from "./httpError"

// 版本信息
export const VERSION = "1.1.0"
